import React from 'react';
import { HashLink as Link } from 'react-router-hash-link';
import { Col, Image, Button } from 'react-bootstrap';

import mainImg from '../../assets/images/greeting-1.png';

const Greeting = () => (
  <div>
    <div className="main-greeting-grid">
      <Col md={4} sm={7} className="col-greeting-first">
        <Col xs={12} className="col-mobile-greeting">
          <Image src={mainImg} responsive />
        </Col>
        <h2 className="greeting-h2">Meet Presence</h2>
        <p className="greeting-text">
          Sure, it’s good to give the first or the last moments to God — but what about the rest of the day? It’s time
          to take your life with God and your awareness of His presence with you everywhere. Not just into your quiet
          times, but into your noisy times, too <span style={{ letterSpacing: 5 }}>...</span>throughout the day, every
          day.
        </p>
        <div className="main-greeting-button">
          <Col md={6} xs={6} className="first-greeting-button">
            <Link smooth scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })} to="/#about">
              <Button bsStyle="info">Learn More</Button>
            </Link>
          </Col>
          <Col md={6} xs={6} className="second-greeting-button">
            <Link
              smooth
              scroll={el => el.scrollIntoView({ behavior: 'smooth', block: 'start' })}
              to="/#subscription-plans"
            >
              <Button bsStyle="primary">Get Started</Button>
            </Link>
          </Col>
        </div>
      </Col>

      <Col md={8} sm={5} className="col-greeting-second">
        <Image src={mainImg} responsive />
      </Col>
    </div>
    <div className="arrow-greeting">
      <span className="chevron-down" />
      {/*<Glyphicon glyph="chevron-down" />*/}
    </div>
  </div>
);

export default Greeting;



// WEBPACK FOOTER //
// ./src/components/Landing/Greeting.js